import { render, staticRenderFns } from "./QuizResult.vue?vue&type=template&id=08da991c&scoped=true&"
import script from "./QuizResult.vue?vue&type=script&lang=js&"
export * from "./QuizResult.vue?vue&type=script&lang=js&"
import style0 from "./QuizResult.vue?vue&type=style&index=0&id=08da991c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08da991c",
  null
  
)

/* custom blocks */
import block0 from "./QuizResult.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports